import React, { Component } from "react";

import { SellToWebAdminModalDialogComponent } from "../common/selltowebmodaldialog/SellToWebAdminModalDialogComponent";
import { SellToWebModalDialogHeaderButtonComponent } from "../common/selltowebmodaldialog/SellToWebModalDialogHeaderButtonComponent";
import { SellToWebAdminTextAreaComponent } from "../common/selltowebtextarea/SellToWebAdminTextAreaComponent";

import { SellToWebSpinnerComponent } from "../common/selltowebspinner/SellToWebSpinnerComponent";

export class TenantOffersRawViewComponent extends Component {
    render() {
        return <SellToWebAdminModalDialogComponent
            title={this.props.rawViewTitle}
            showDialog={this.props.showRawViewPopup}
            className="admin-offers-raw-view-dialog"
            onCancelClick={this.props.onCancelRawView}
        >
            <SellToWebModalDialogHeaderButtonComponent>
                <button className="btn btn-primary admin-copy-button" onClick={(event) => this.props.onCopyRawView(event)}>
                    Copy <span className="far fa-copy admin-icon" />
                </button>
            </SellToWebModalDialogHeaderButtonComponent>
            {
                this.props.rawViewData
                    ? <div className="admin-body">
                        <SellToWebAdminTextAreaComponent id="offerRawView" value={this.props.rawViewData} rows="25" controlSpan="col-12" readOnly />
                    </div>
                    : <SellToWebSpinnerComponent showSpinner={!this.props.rawViewData} />
            }
        </SellToWebAdminModalDialogComponent>
    }
}